// extracted by mini-css-extract-plugin
export default {"main_con":"FIleDownloadStyles_main_con__Vs2V7","text":"FIleDownloadStyles_text__5c6Qj","button":"FIleDownloadStyles_button__7iS1p"};